import type { DefaultTheme } from 'styled-components';

export const getColor = ({ color, disabled, alt, theme }: { color?: string; disabled?: boolean; alt?: boolean; theme: DefaultTheme }) => {
  if (disabled) {
    return theme.colors.grey70_1;
  }
  if (color) {
    return color;
  }
  if (alt) {
    return theme.colors.grey00_2;
  }
  return theme.colors.black_1;
};
